var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticClass:"logo",attrs:{"src":_vm.appLogoImage,"fluid":""}})}
var staticRenderFns = []

export { render, staticRenderFns }